import React from 'react';

const AddOrEditCafeContract = React.createContext();

export default AddOrEditCafeContract;
